import { PolotnoContainer, SidePanelWrap, WorkspaceWrap } from "polotno";
import { DEFAULT_SECTIONS, SidePanel } from "polotno/side-panel";
import { Toolbar } from "polotno/toolbar/toolbar.js";
import { Workspace } from "polotno/canvas/workspace.js";
import { ZoomButtons } from "polotno/toolbar/zoom-buttons.js";
import React from "react";
import { UploadPanel } from "./upload-panel.js";
import { ResizePanel, setBackground } from "./resize-panel.js";

import { TextPanel as CustomTextPanel } from "./text-panel.js";

// overwrite photos panel
const UploadSection = DEFAULT_SECTIONS.find(
  (section) => section.name === "photos"
);
UploadSection.Panel = UploadPanel;

// overwrite size panel
const ResizeSection = DEFAULT_SECTIONS.find(
  (section) => section.name === "size"
);

ResizeSection.Panel = ResizePanel;

const TextSection = DEFAULT_SECTIONS.find((section) => section.name === "text");
TextSection.Panel = CustomTextPanel;

// remove uploads panel
const panelsToRemove = ["upload"];

export const App = ({ store }) => {
  if (!window.uploadUrl) {
    panelsToRemove.push("photos");
  }
  console.log(window.CUSTOM_SIZES.length);
  console.log(store.width, store.height);
  if (window.CUSTOM_SIZES.length < 2) {
    // omit resize button
    panelsToRemove.push("size");
  }
  return (
    <PolotnoContainer style={{ width: "100%", height: "100vh" }}>
      <SidePanelWrap>
        <SidePanel
          sections={[
            ...DEFAULT_SECTIONS.filter(
              (panel) => !panelsToRemove.includes(panel.name)
            ),
          ]}
          store={store}
          defaultSection="size"
        />
      </SidePanelWrap>
      <WorkspaceWrap>
        <Toolbar store={store} downloadButtonEnabled />
        <Workspace store={store} components={{ PageControls: () => null }} />
        <ZoomButtons store={store} />
      </WorkspaceWrap>
    </PolotnoContainer>
  );
};
